import apiClient from './apiClient';

export interface QueryParams {
  deliveryNo: string;
}

export interface PaymentDetail {
  delivery_no: string;
  doc_no: string;
  doc_date: string;
  amount: number;
  type_code: string;
  type_label: string;
  status: string;
  approval_date: string;
  unapproved_mk: string;
  running_bal: number;
}

export interface TotalAmountSource {
  table: string;
  total_amt: number;
  is_approved: boolean;
}

export interface QueryResult {
  data: PaymentDetail[];
  total_amt: number;
  count: number;
  source?: TotalAmountSource;
}

export const pwg332Api = {
  async query(params: QueryParams): Promise<QueryResult> {
    const res = await apiClient.post('/api/pwg332/query', params);
    return res.data;
  },
};
